export enum ClientNames {
  consoleTd = 'console-td',
  consoleTdSf = 'console-td-sf',
  consoleSf = 'console-sf',
  console = 'console',
}
